export const fetchWithTimeout = async (url, options = {}, timeoutMs = 5000) => {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const resp = await fetch(url, { ...options, signal: controller.signal })
    return resp
  } finally {
    clearTimeout(id)
  }
}

export const formatCoordinates = (lon, lat) => ({ type: 'Point', coordinates: [Number(lon), Number(lat)] })

export const geocodeCity = async (q, lang = 'es') => {
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language=${encodeURIComponent(lang)}&q=${encodeURIComponent(String(q).trim())}`
  const resp = await fetchWithTimeout(url, {}, 5000)
  if (!resp.ok) throw new Error('geocode_failed')
  const results = await resp.json()
  if (Array.isArray(results) && results.length > 0) {
    const { lat, lon } = results[0]
    return formatCoordinates(lon, lat)
  }
  return null
}

export const reverseGeocode = async (lat, lon, lang = 'es') => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&accept-language=${encodeURIComponent(lang)}&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`
  const resp = await fetchWithTimeout(url, {}, 5000)
  if (!resp.ok) throw new Error('reverse_failed')
  const data = await resp.json()
  const addr = data?.address || {}
  const cityName = addr.city || addr.town || addr.village || addr.county || addr.state || data?.display_name || ''
  return cityName || ''
}

export const getCoordsFromBrowser = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error('geolocation_unavailable'))
  navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 10000 })
})
